module.exports = __webpack_public_path__ + "static/media/image_video_MoP.e78543d2.jpg";